import { AddButton } from "./buttons/AddButton";
import { AbstractStandardTableToolsPanel } from "./AbstractStandardTableToolsPanel";
import { Component } from "../../../../base/Component";
import { PanelProps } from "../../../panel/PanelProps";
import { Table } from "../../Table";

enum InnerIds {
    BUTTON_ADD = "buttonAdd"
}

export class StandardRightToolsPanel extends AbstractStandardTableToolsPanel {
    buttonAdd: AddButton;

    constructor(table: Table, props?: Partial<PanelProps>) {
        super(table, { ...props, rowBreak: true });
        this.addMountListener(() => this.buttonAdd?.syncCaption());
    }

    override syncInnerComponentIds() {
        this.setInnerComponentId(this.buttonAdd.get(), InnerIds.BUTTON_ADD);
    }

    override createComponents() {
        this.buttonAdd = new AddButton(this.table);
        this.buttonAdd.get().id = this.createInnerComponentId(InnerIds.BUTTON_ADD);
    }

    override sync() {
        this.removeAll();
        this.addTool(this.table.isNormalAddAllowed(), this.buttonAdd?.get());
    }

    protected override addTool(condition: boolean, tool: Component) {
        super.addTool(condition, tool);
        if (condition === true && tool === this.buttonAdd?.get()) {
            // Because we sync the table tools more than once, we need to give the Add button a chance to build its
            // caption based on the parent layout after the button has been added to the table.
            this.buttonAdd?.syncCaption();
        }
    }

    override getPopulatedPaddingLeft(): number {
        return 4;
    }

    override getPopulatedPaddingRight(): number {
        return 0;
    }
}
